import React from "react";
import { connect } from "react-redux";
import { IEditorState, openImageUpload } from "../../redux";
import { TextField, Select, MenuItem, IconButton } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/cloudupload";
import { DynamoNode, ImageNode } from "dynamo-models";

interface IImageSelectionProps {
    startImageUpload: () => void;
    selectedNode?: DynamoNode;
    onUrlChanged: (event) => void;
}

class ImageSelectionWidget extends React.Component<IImageSelectionProps> {
    public render() {
        let urlVal;
        let imageNode = new ImageNode();

        if (this.props.selectedNode !== undefined && this.props.selectedNode.tag === "Element") {
            imageNode = this.props.selectedNode as ImageNode;
            urlVal = imageNode.url;
        }

        return (
            <div style={({
                display: "flex",
                margin: "0.5em",
            })}>
                <TextField
                    key="urlField"
                    type="text"
                    label="URL"
                    value={imageNode.url}
                    onChange={this.props.onUrlChanged}
                    style={({
                        flexGrow: 1,
                    })}
                />
                <IconButton color="primary" style={({
                    margin: "0.5em",
                })}>
                    <CloudUploadIcon onClick={this.props.startImageUpload} />
                </IconButton>
            </div>
        );
    }
}

const stateToProps = (state: IEditorState) => ({
    selectedNode: state.selectedNode,
});

const dispatchToProps = (dispatch) => ({
    startImageUpload: () => dispatch(openImageUpload()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});

export const EditorImageSelectionWidget = connect(stateToProps, dispatchToProps, mergeProps)(ImageSelectionWidget);